import { Link, useLocation } from 'react-router-dom';
import Logo from './marketing/Logo';
import { INFO_EMAIL } from '../lib/config';

interface FooterProps {
  /** When true (custom logo is set on the lot), show a "Powered by ParkConfetti" pill instead of the full logo */
  hasCustomLogo?: boolean;
}

function Footer({ hasCustomLogo = false }: FooterProps) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="flex flex-col items-center gap-3 text-sm text-ink-500 pt-5 border-t border-ink-300/40">
      {hasCustomLogo ? (
        <a
          href="https://parkconfetti.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-ink-200 bg-cream-50 hover:bg-cream-100 transition-colors"
        >
          <span className="text-xs text-ink-400">Powered by</span>
          <Logo size={14} showWordmark={false} />
          <span className="text-xs text-ink-400 font-medium">Park Confetti</span>
        </a>
      ) : (
        <Logo size={24} />
      )}
      <a
        href={`mailto:${INFO_EMAIL}`}
        className="text-confetti-pink hover:text-confetti-pink/80 transition-colors"
      >
        {INFO_EMAIL}
      </a>
      <Link
        to={isAdminRoute ? '/' : '/admin'}
        className="text-ink-400 hover:text-ink-700 transition-colors"
      >
        {isAdminRoute ? '← Back to home' : 'Lot owner login'}
      </Link>
    </div>
  );
}

export default Footer;
